module.exports = __webpack_public_path__ + "img/Greta.ef6a683f.png";